<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.Cities.add") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameAr')" v-model.trim="data.nameAr" required />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameEn')" v-model.trim="data.nameEn" required />
          <!-- End:: Name Input -->

          <base-select-input col="6" v-if="getCountriesData" :optionsList="getCountriesData" :placeholder="$t('PLACEHOLDERS.country')"
                             v-model="data.country_id" />
          
          <base-select-input col="6" :optionsList="regions" :placeholder="$t('TABLES.Areas.name')"
            v-model="data.region_id" :noOptions="noOptionMessage()" />

          <!-- Start:: Name Input -->
          <base-input col="6" type="number" :placeholder="$t('PLACEHOLDERS.delivery_cost')" v-model.trim="data.delivery_cost" required />
          <!-- End:: Name Input -->


          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch color="green" :label="data.active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"
              v-model="data.active" hide-details></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button class="mt-2" styleType="primary_btn" :btnText="$t('BUTTONS.save')" :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest" />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateCity",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        region_id: null,
        country_id: null,
        delivery_cost: null,
        active: true,
      },
      noOptionMeg:"",
      regions: []
      // End:: Data Collection To Send
    };
  },
  watch: {
    'data.country_id'(obj){
      this.getRegions(obj.id)
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },
  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),
  },

  methods: {
    // Start:: Vuex Actions
  ...mapActions({
      getCountries: "ApiGetsModule/getCountries",
    }),
      // End:: Vuex Actions
      noOptionMessage() {
    if(this.data.country_id){
      this.noOptionMeg=this.$t('PLACEHOLDERS.this country has no Area');
    }else{
      this.noOptionMeg=this.$t('PLACEHOLDERS.choose country first');
    }
    return this.noOptionMeg;
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (!this.data.country_id) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.country_id"));
        return;
      }else if (!this.data.region_id) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.area"));
        return;
      } 
      // else if (!this.data.delivery_cost) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.delivery_cost"));
      //   return;
      // } 
      else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("ar[name]", this.data.nameAr);
      REQUEST_DATA.append("en[name]", this.data.nameEn);
      if (this.data.region_id) {
        REQUEST_DATA.append("state_id", this.data.region_id?.id);
      }
      if (this.data.country_id) {
        REQUEST_DATA.append("country_id", this.data.country_id?.id);
      }
      REQUEST_DATA.append("is_active", +this.data.active);
      REQUEST_DATA.append("delivery_cost", +this.data.delivery_cost);
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `cities`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/cities/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    async getRegions(country_id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `states-by-country/${country_id}`,
        });
        // console.log("Cities =>", res.data.data);
        this.regions = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },


  },

  created() {
    // this.getRegions()
  this.getCountries()
  },
};
</script>
